import * as types from "../../actions/types";



const initialState = null


export default function control (state = initialState, action) {
  switch (action.type) {
      
    case types.SET_SETTINGS_CONTROL_DATA:
      return action.payload

    default:
      return state;
  }
}